import type {
  ScheduledConference,
  ScheduledConferenceBase,
  ScheduledTask,
  ScheduleEvent,
} from '../types';

import {getUuid} from '../../../../../utils/getUuid';
import {isDefined} from '../../../../../utils/typecheck';
import {ScheduleItemRepeat} from '../utils';

export const groupEditionConferences = (
  conferences: ScheduledConferenceBase[],
): ScheduledConference[] => {
  const groups: {[key: number]: ScheduledConferenceBase[]} = {};

  const groupByUuid = (conference: ScheduledConferenceBase) => {
    const groupId = conference.uuid;

    groups[groupId] = groups[groupId] || [];
    groups[groupId].push(conference);
  };

  conferences.forEach(groupByUuid);

  return Object.keys(groups).map(uuid => {
    const group = groups[uuid] as ScheduledConferenceBase[];

    let repeat: ScheduledConference['repeat'] = {
      days: null,
      type: 'once',
    };

    if (group.length > 1) {
      repeat = {
        days: group[1]!.day - group[0]!.day,
        type: 'interval',
      };
    }

    const confWithRepeat: ScheduledConference = {
      ...group[0]!,
      repeat,
    };

    return confWithRepeat;
  });
};

export const repeatScheduleEvents = (
  items: ScheduleEvent[],
  duration: number,
) => {
  const result: ScheduleEvent[] = [];

  items.forEach(item => {
    if (item.repeat.type === 'once') {
      result.push(item);
    } else {
      result.push(item);

      const interval = item.repeat.days!;

      let {day} = item;

      let {stop_day} = item as ScheduledTask;

      if (isDefined(stop_day)) {
        stop_day += 1;
      }

      while ((day += interval) < (stop_day || duration)) {
        result.push({
          ...item,
          day,
          edition_uuid: getUuid(),
        });
      }
    }
  });

  return result;
};

export const REPEATS = [
  ScheduleItemRepeat.ONE_TIME!,
  ScheduleItemRepeat.DAILY!,
  ScheduleItemRepeat.WEEKLY!,
  ScheduleItemRepeat.BI_WEEKLY!,
  ScheduleItemRepeat.MONTHLY!,
];
